import { Dialog, Transition } from '@headlessui/react'
import { XCircleIcon } from '@heroicons/react/24/outline'
import React, { Fragment } from 'react'

function PlayerModal({isOpen, closeModal, modalInputs, title}) {
  return (
    <Transition className="font-GoogleSans tracking-wider" appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center p-3 sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-sm transform select-none overflow-hidden rounded-lg bg-white pt-4 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="font-bold leading-6 px-4 pb-2 text-gray-900 border-b"
                  >
                    <div className='flex justify-between gap-2'><div className='text-sm'>{sessionStorage.getItem('processName') || sessionStorage.getItem('projectName') ? (<span className='font-bold'>{sessionStorage.getItem('processName') || sessionStorage.getItem('projectName')}: </span>) : null}<span className={sessionStorage.getItem('processName')? 'italic':'font-bold'}>{title}</span></div><button onClick={closeModal} className='cursor-default lg:cursor-pointer'><XCircleIcon className='h-6 w-auto'/></button></div>
                  </Dialog.Title>
                  <div>
                    {modalInputs}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
  )
}

export default PlayerModal